import FormModal from './formModal';

export default FormModal;
